import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForConfluenceBuyReverseTrial(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		invoiceableStatus,
		isInReverseTrial,
		isInTrial,
		isInPredunning,
		isInCollection,
		userRoles,
		canAddPaymentDetails,
		canUpgrade,
	} = context;

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		product === 'confluence' &&
		edition === 'premium' &&
		(isInTrial || isInPredunning) &&
		isInReverseTrial &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		userRoles?.includes('BILLING_ADMIN') &&
		canAddPaymentDetails &&
		canUpgrade,
	);
}
